import { LicenseEntityModel } from "src/store/models/entity/license/entity";
import { LicenseHelperModel } from "src/store/models/entity/license/helper";

export const encooLicenseBindings = {
  entity: LicenseEntityModel,
  helper: LicenseHelperModel,
};
